<template>
  <AppChip v-if="competition.isGrandPrix" color="accent" small
    >{{ $t("common:competition.isGrandPrix.label", "GP") }}
  </AppChip>
</template>
<script>
import gql from "fraql";
import AppChip from "@elements/AppChip.vue";

export default {
  name: "AppShowCompetitionGrandPrix",
  components: {
    AppChip
  },
  props: {
    competition: {
      type: Object,
      required: true
    }
  },
  fragments: {
    grandPrix: gql`
      fragment _ on Competition {
        isGrandPrix
      }
    `
  }
};
</script>
